export { HotelMap } from './HotelMap';
